export default {
	title: "Temas",
	darkMode: "Modo Oscuro",
	orixas: {
		ori: "ORI",
		exu: "Exú",
		ogum: "Ogum",
		oxossi: "Oxóssi",
		xango: "Xangô",
		oxum: "Oxum",
		iemanja: "Iemanjá",
		oxala: "Oxalá",
		nana: "Nanã",
		iansa: "Iansã",
		ibeji: "Ibeji",
	},
	descriptions: {
		ori: "Tema predeterminado del sistema ORI",
		exu: "Guardián de los caminos - Negro con Rojo",
		ogum: "Orixá de los caminos y la guerra - Rojo",
		oxossi: "Orixá de la caza y la abundancia - Verde y Azul",
		xango: "Orixá de la justicia y los rayos - Marrón y Blanco",
		oxum: "Orixá de los ríos y el amor - Azul Oscuro",
		iemanja: "Reina del mar - Azul y Blanco",
		oxala: "Padre de todos los orixás - Blanco puro",
		nana: "Orixá ancestral - Púrpura y Lila",
		iansa: "Señora de los vientos y tempestades - Amarillo y Coral",
		ibeji: "Orixás gemelos de la alegría - Azul claro y Rosa",
	},
};
